import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeReceiptDateCommand extends BaseCommand {
  CommandName = "ChangeReceiptDate";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
